// extracted by mini-css-extract-plugin
export default {"container":"adminHeader_container__tmiSI"};